import * as React from "react";

import { GridColumnMenuCheckboxFilter, GridColumnMenuProps } from "@progress/kendo-react-grid";

export function ContainerNetworkColumnMenu(props: GridColumnMenuProps) {
  const data = [{ ContainerNetwork: "P" }, { ContainerNetwork: "S" }];

  return (
    <GridColumnMenuCheckboxFilter
      expanded
      filterable
      {...props}
      data={data}
      searchBox={() => null}
    />
  );
}
